import React from "react";
import SideBar from "./SideBar";
import useWindowSize from "../hooks/WindowResizer";
import Header from "./Header";

const Layout = ({ children }) => {
  const isMobileView = useWindowSize();
  return (
    <div className="layout-root">
      {!isMobileView && <SideBar />}
      <Header />
      <main>{children}</main>

      <style>
        {`.makeStyles-App_root-3 {
        background: #F9f9f9 !important;
      }
      `}
      </style>
    </div>
  );
};

export default Layout;
